module.exports = __webpack_public_path__ + "img/pfander.1f44c867.jpg";